var render = function render(){var _vm=this,_c=_vm._self._c;return _c('subsystem-iframe-shell',{attrs:{"external-path":"/project/waterSupplyAndDrainageSubsystem","frame-title":"给排水"}})
}
var staticRenderFns = []

export { render, staticRenderFns }